import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogCompleteEditFolderList = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({ name: 'COMPLETE_EDIT_FOLDER_LIST' });
  }, [logAnalyticsEvent]);
};
